// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","532":"styles","883":"component---src-pages-404-js"}[chunkId] + "-" + {"230":"34d2cafb3789ddc97a32","532":"4fffce1ecfea467ce4da","883":"5f94a5baa07013612b8d"}[chunkId] + ".js";
};